import * as modalTypes from "../../../../constants/modalTypes";
import * as objectTypes from "../../../../constants/objectTypes";
import * as optionHelper from "../../../../helpers/optionHelper";
import * as propertyConstants from "../../../../constants/propertyConstants";
import * as translationHelper from "../../../../helpers/translationHelper";

import {
    ColorantBatch,
    createEmptyColorantBatch,
    generateColorantBatchData,
    generateColorantBatchHeadings
} from "../../../../types/colorantBatch";
import React, { Component } from "react";

import { Colorant } from "../../../../types/colorant";
import { ModalParams } from "../../../../types/modalParams";
import { ModalProperties } from "../../../../types/modalProperties";
import { TableContainer } from "../../../Table";
import { TableHeading } from "../../../../types/tableHeading";

import { t as translate } from "react-i18nify";

type Props = {
    tableConstant: string;
    objectType: objectTypes.ObjectType;
    dataPrivileges: any;
    loading: boolean;
    buttonLoading: boolean;
    allList: Array<ColorantBatch>;
    activeList: Array<ColorantBatch>;
    colorantActiveList: Array<Colorant>;
    columnOrder: Array<propertyConstants.Property>;
    columnVisibility: Record<propertyConstants.Property, boolean>;
    columnWidth: Record<propertyConstants.Property, number>;
    offset: number;
    page: number;
    rowCount: number;
    rowCountCustom: boolean;
    search: string | null;
    searchParams: Record<propertyConstants.Property, string>;
    showFilterRow: boolean;
    showGlobalSearch: boolean;
    sortingAsc: boolean;
    sortingCriterion: propertyConstants.Property | null;
    totalCount: number | null;
};

export class MasterColorantBatchTable extends Component<Props> {
    generateTableHeadings = (modalType: modalTypes.ModalType | null = null): Array<TableHeading> => {
        const propertyList: Array<propertyConstants.Property> = [
            propertyConstants.PROPERTY_STATUS_ID,
            propertyConstants.PROPERTY_BATCH_NUMBER,
            propertyConstants.PROPERTY_PRODUCTION_DATE,
            propertyConstants.PROPERTY_MORE_INFO
        ];

        const requiredList: Array<propertyConstants.Property> = [
            propertyConstants.PROPERTY_BATCH_NUMBER,
            propertyConstants.PROPERTY_STATUS_ID
        ];
        const alwaysVisibleList: Array<propertyConstants.Property> = [propertyConstants.PROPERTY_BATCH_NUMBER];
        const editableList: Array<propertyConstants.Property> = [
            propertyConstants.PROPERTY_STATUS_ID,
            propertyConstants.PROPERTY_BATCH_NUMBER,
            propertyConstants.PROPERTY_MORE_INFO
        ];
        let visibleList: Array<propertyConstants.Property> = [...propertyList];
        let orderList = [...visibleList];

        if (modalType !== null) {
            editableList.splice(2, 0, propertyConstants.PROPERTY_PRODUCTION_DATE);
        }

        if (modalType === null) {
            visibleList.splice(3, 0, propertyConstants.PROPERTY_LAST_STATUS_CHANGE);

            orderList = optionHelper.handleTableHeadingOrder(visibleList, this.props.columnOrder);
            visibleList = optionHelper.handleTableHeadingVisibility(visibleList, this.props.columnVisibility);
        }

        return generateColorantBatchHeadings(
            this.props.objectType,
            orderList,
            visibleList,
            editableList,
            requiredList,
            alwaysVisibleList,
            this.props.columnWidth
        );
    };

    generateAddModalParams = (): ModalParams | null => {
        if (this.props.colorantActiveList.length) {
            return new ModalParams(
                modalTypes.ADD_MODAL,
                this.props.objectType,
                translate("colorant.addColorantBatch"),
                createEmptyColorantBatch(this.props.colorantActiveList[0]),
                this.generateTableHeadings(modalTypes.MODAL_COLORANT_BATCHES_ADD)
            );
        }

        return null;
    };

    generateEditModalParams = (): ModalParams | null => {
        const activeData = generateColorantBatchData(this.props.activeList);

        if (activeData.length) {
            return new ModalParams(
                modalTypes.EDIT_MODAL,
                this.props.objectType,
                translate("colorant.editColorantBatch"),
                activeData[0],
                this.generateTableHeadings(modalTypes.MODAL_COLORANT_BATCHES_EDIT)
            );
        }

        return null;
    };

    render(): JSX.Element {
        const modalProperties: ModalProperties = {
            addModalType: modalTypes.MODAL_COLORANT_BATCHES_ADD,
            addModalParams: this.generateAddModalParams(),
            editModalType: modalTypes.MODAL_COLORANT_BATCHES_EDIT,
            editModalParams: this.generateEditModalParams()
        };

        return (
            <div className="height-100">
                <TableContainer
                    className={"table-with-filter"}
                    tableConstant={this.props.tableConstant}
                    objectType={this.props.objectType}
                    dataPrivileges={this.props.dataPrivileges}
                    loading={this.props.loading}
                    buttonLoading={this.props.buttonLoading}
                    title={translationHelper.getTitleSectionTranslation(this.props.objectType)}
                    titleClassName={"title"}
                    headings={this.generateTableHeadings()}
                    data={generateColorantBatchData(this.props.allList)}
                    activeData={this.props.activeList}
                    offset={this.props.offset}
                    page={this.props.page}
                    rowCount={this.props.rowCount}
                    rowCountCustom={this.props.rowCountCustom}
                    search={this.props.search}
                    searchParams={this.props.searchParams}
                    showFilterRow={this.props.showFilterRow}
                    showGlobalSearch={this.props.showGlobalSearch}
                    sortingAsc={this.props.sortingAsc}
                    sortingCriterion={this.props.sortingCriterion}
                    totalCount={this.props.totalCount}
                    modalProperties={modalProperties}
                />
            </div>
        );
    }
}
